import Swal from 'sweetalert2'
import {
    deleteByIdFamilias,
    recoverFamiliaDeleted,
} from '../../../Services/familiaService'

const useDelete = (setIsLoad) => {
    const recoverFamiliaSubmit = (familia) => {
        Swal.fire({
            title: 'Estas seguro de recuperarlo?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Recuperar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                // consulta a la api para eliminar
                familia.activo = false
                recoverFamiliaDeleted(familia.id)
                    .then((res) => {
                        Swal.fire(
                            'Recuperado!',
                            'La familia fue recuperada.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: 'Hubo un error vuelve a intentar!',
                        })
                        console.log(error.response)
                    })
            }
        })
    }

    const deleteFamilia = (familia) => {
        Swal.fire({
            title: 'Estas seguro de eliminar?',
            text: 'Se eliminara una familia!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Eliminar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                deleteByIdFamilias(familia.id)
                    .then((res) => {
                        Swal.fire(
                            'Eliminado!',
                            'La familia fue eliminado.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: 'Hubo un error vuelve a intentar!',
                        })
                        console.log(error.response)
                    })
            }
        })
    }

    return { recoverFamiliaSubmit, deleteFamilia }
}

export default useDelete
